/* 列傳的任務系統（跑在模擬端，無頭測試也能跑）
 * 一章是一串步驟 steps：進入時 enter(m, w)，每一步 tick(m, w, dt) 回傳 true 就進下一步；always 每一步都會跑（勝負、巡邏）。
 * m 上的小工具：任務目標 obj/prog/done、地圖標記 mark、字幕 line、旁白卡 card、延遲 after、生兵 foe/recruit、技能鎖 lock/unlock、勝負 win/lose。
 * 畫面那邊（game.ts、campaign/draw.ts）只讀 m 的狀態與 w.msgs，不改模擬。 */
// @ts-nocheck
import { SG } from '../core/sg.ts';

// 列傳的黃巾兵（比赤壁野區的弱，數量多）
const FOES = {
  huangjin: { hp: 360, atk: 20, armor: 2, r: 20, ms: 235, gold: 25, xp: 45 },
  bandit: { hp: 950, atk: 34, armor: 4, r: 26, ms: 240, gold: 70, xp: 110 },
};

const M_ = {
  next() {
    const s = this.def.steps[++this.i];
    this.t = 0;
    if (s && s.enter) s.enter(this, this.w);
  },
  tick(dt) {
    if (this.over) return;
    const w = this.w;
    if (this.timers.length) { const due = []; this.timers = this.timers.filter((tm) => { tm.t -= dt; if (tm.t <= 0) { due.push(tm); return false; } return true; }); due.forEach((tm) => tm.fn()); }
    this.t += dt;
    for (const k of this.marks) if (k.u && k.u.alive) { k.x = k.u.x; k.y = k.u.y; }
    this.boatsTick(dt);
    this.warnsTick(dt);
    this.firesTick(dt);
    this.chansTick(dt);
    this.patrols();
    this.searches(dt);
    this.gateTalk();
    this.pickups();
    this.folksTick(dt);
    this.followers(dt);
    this.count();
    if (this.def.always) this.def.always(this, w, dt);
    if (this.over) return;
    const s = this.def.steps[this.i];
    if (s && s.tick && s.tick(this, w, dt)) this.next();
  },
  // ---- 任務目標（Tab 與左上角的任務欄顯示）----
  obj(id, text, of) { const o = { id, text, n: 0, of: of || 0, done: false }; this.objs.push(o); return o; },
  get(id) { return this.objs.find((o) => o.id === id); },
  prog(id, n) { const o = this.get(id); if (!o) return; o.n = n; if (o.of && n >= o.of) o.done = true; },
  done(id) { const o = this.get(id); if (o) o.done = true; },
  drop(id) { this.objs = this.objs.filter((o) => o.id !== id); },
  // ---- 地圖標記：畫面上的金色箭頭、小地圖上的點 ----
  mark(id, x, y, label, small, u) { this.unmark(id); this.marks.push({ id, x, y, label, small: !!small, u }); }, // u：標記跟著這個單位走
  unmark(id) { this.marks = this.marks.filter((k) => k.id !== id); },
  // ---- 字幕、旁白卡、橫幅 ----
  line(who, text) { this.w.msgs.push({ t: this.w.t, kind: 'line', who, text }); },
  card(text, src) { this.w.msgs.push({ t: this.w.t, kind: 'card', text, src }); },
  big(text) { this.w.say(text, 'big'); },
  after(t, fn) { this.timers.push({ t, fn }); },
  // ---- 單位 ----
  foe(k, x, y, o) {
    const S = FOES[k], [px, py] = SG.MAP.walkable(x, y, SG.MAP.BODY) ? [x, y] : SG.MAP.nearestFree(x, y);
    const u = SG.unit(Object.assign({ kind: 'creep', spec: SG.NEUTRAL[k], team: 1, x: px, y: py, home: [px, py], f: -1, r: S.r, hp: S.hp, maxHp: S.hp, atk: S.atk, armor: S.armor, asp: 100, ms: S.ms, range: 70,
      gold: S.gold, xp: S.xp, name: SG.NEUTRAL[k].name, think: 0 }, o || {}));
    this.w.units.push(u);
    return u;
  },
  // 一圈敵兵：list = [[種類, 數量], ...]
  camp(x, y, list, r = 150) {
    const out = [];
    let n = 0;
    const total = list.reduce((s, [, c]) => s + c, 0);
    for (const [k, c] of list) for (let i = 0; i < c; i++, n++) { const a = (n / total) * Math.PI * 2; out.push(this.foe(k, x + Math.cos(a) * r * (k === 'bandit' ? 0.3 : 1), y + Math.sin(a) * r * 0.7 * (k === 'bandit' ? 0.3 : 1))); }
    return out;
  },
  // 我方鄉勇：先站著，join 之後跟著主角走、看到敵人就打
  recruit(x, y, name) {
    const spec = SG.SOLDIERS.wu, [px, py] = SG.MAP.walkable(x, y, SG.MAP.BODY) ? [x, y] : SG.MAP.nearestFree(x, y);
    const u = SG.unit({ kind: 'minion', spec, team: 0, x: px, y: py, home: [px, py], f: 1, r: 18, hp: 420, maxHp: 420, atk: 18, armor: 2, asp: 100, ms: 290, range: 70, name: name || '鄉里少年', recruit: true });
    this.w.units.push(u);
    return u;
  },
  join(u, lead) { u.home = null; u.owner = lead; u.holdAt = null; },
  // 巡邏：沿著 pts 來回走（看到敵人照樣追打，追丟了回到巡邏路線）
  patrol(u, pts) { u.patrol = pts; u.pi = 0; u.home = pts[0].slice(); },
  patrols() {
    for (const u of this.w.units) {
      if (!u.patrol || !u.alive || (u.target && u.target.alive)) continue;
      if (SG.gd(u.x, u.y, u.home[0], u.home[1]) < 40) { u.pi = (u.pi + 1) % u.patrol.length; u.home = u.patrol[u.pi].slice(); }
    }
  },
  // 搜索：在一片草野裡放慢腳步找人。每次挑一個沒人在找的點（草叢邊緣，偶爾探進草裡），走到了就停下來左右張望一陣子
  // pts：[x, y, 草叢編號（探進草裡的點才有）]；探草不探 who 正躲著的那片（進了同一片草就一定會看到）
  search(u, pts, who) { u.patrol = null; u.search = { pts, who, wait: 0.3 + SG.rand() * 1.5, look: 0, goal: null }; u.home = [u.x, u.y]; u.ms0 = u.ms0 || u.ms; },
  searches(dt) {
    const list = this.w.units.filter((u) => u.search && u.alive);
    for (const u of list) {
      const S = u.search;
      if (u.target && u.target.alive) { u.ms = u.ms0; S.goal = null; S.wait = 0; continue; } // 看到人了：全速追
      u.ms = u.ms0 * 0.6;
      const hb = S.who && S.who.alive ? SG.MAP.brush[SG.MAP.brushAt(S.who.x, S.who.y)] : null;
      if (hb) { // 繞路繞到他躲的那片草邊上：掉頭往外走（進了同一片草就一定會看到，那就不是找人、是撞見）
        const ex = (u.x - hb[0]) / hb[2], ey = (u.y - hb[1]) / hb[3], e = Math.hypot(ex, ey);
        if (e < 1.12) { S.goal = [hb[0] + (ex / (e || 1)) * hb[2] * 1.3, hb[1] + (ey / (e || 1)) * hb[3] * 1.3]; u.home = S.goal; continue; }
      }
      if (S.goal && SG.gd(u.x, u.y, S.goal[0], S.goal[1]) > 30) { u.home = S.goal; continue; }
      if (S.goal) { S.goal = null; S.wait = 1.4 + SG.rand() * 2; S.look = 0; }
      if (S.wait > 0) { // 張望：左右轉頭
        S.wait -= dt; S.look -= dt; u.home = [u.x, u.y];
        if (S.look <= 0) { u.f = -u.f || 1; S.look = 0.5 + SG.rand() * 0.7; }
        continue;
      }
      const hide = S.who && S.who.alive ? SG.MAP.brushAt(S.who.x, S.who.y) : -1;
      const taken = list.filter((o) => o !== u && o.search.goal).map((o) => o.search.goal);
      const cross = (p) => { if (hide < 0) return false; for (let j = 1; j < 10; j++) if (SG.MAP.brushAt(u.x + ((p[0] - u.x) * j) / 10, u.y + ((p[1] - u.y) * j) / 10) === hide) return true; return false; }; // 路上會穿過那片草
      const safe = S.pts.filter((p) => p[2] !== hide && !cross(p) && SG.gd(p[0], p[1], u.x, u.y) > 150);
      const ok = safe.filter((p) => SG.gd(p[0], p[1], u.x, u.y) < 1100 && !taken.some((g) => SG.gd(g[0], g[1], p[0], p[1]) < 260));
      const from = ok.length ? ok : safe;
      if (!from.length) { S.wait = 1; continue; } // 沒有能去的點：多張望一會
      const p = from[Math.floor(SG.rand() * from.length)];
      S.goal = [p[0], p[1]]; u.home = S.goal;
    }
  },
  // 鄉勇：帶頭的人附近有敵人，就分頭去打不同的敵人；沒有敵人就在身後排成陣形；帶頭的人隱身時原地待命（免得打草驚蛇）
  // 陣形跟著帶頭的人「行進方向」（平滑過的速度）轉，不跟面向；目標點往前多抓半秒的路，走路中途不會追到又停、停了又走
  followers(dt) {
    const w = this.w, groups = new Map();
    for (const u of w.units) if (u.recruit && u.alive && u.owner) { if (!groups.has(u.owner)) groups.set(u.owner, []); groups.get(u.owner).push(u); }
    for (const [o, list] of groups) {
      const hold = !o.alive || o.st.invis > 0, F = this.formOf(o, dt || 1 / 30);
      const foes = hold ? [] : w.units.filter((t) => t.alive && t.team === 1 && !t.untargetable && !t.asleep && t.vis[o.team] && SG.gd(t.x, t.y, o.x, o.y) < 650) // 熟睡的敵人不去吵醒
        .sort((a, b) => SG.gd(a.x, a.y, o.x, o.y) - SG.gd(b.x, b.y, o.x, o.y));
      list.forEach((u, i) => {
        const ms0 = u.ms0 || (u.ms0 = u.ms);
        u.ms = ms0;
        if (hold) { u.holdAt = u.holdAt || [u.x, u.y]; u.home = u.holdAt; u.target = null; u.think = 0.35; return; }
        u.holdAt = null;
        if (u.noFight) { u.target = null; u.think = 0.35; } // 不打仗的人（家眷、甘夫人）：只跟著走
        else if (foes.length) {
          if (!(u.target && foes.includes(u.target))) u.target = foes[i % foes.length];
          u.think = 0.35; // 不讓 creepAI 換成自己身邊最近的那個
          return;
        }
        const row = Math.floor(i / 4), col = (i % 4) - 1.5; // 身後兩排、每排四人
        // 陣位平滑地挪（轉彎時足跡的左右會換邊，不平滑會一下跳過去）
        const q = this.slot(F, o, 90 + row * 60, col * 55), k = Math.min(1, (dt || 1 / 30) * 4);
        if (!u.slotS || SG.gd(u.slotS[0], u.slotS[1], q[0], q[1]) > 400) u.slotS = q; else u.slotS = [u.slotS[0] + (q[0] - u.slotS[0]) * k, u.slotS[1] + (q[1] - u.slotS[1]) * k];
        const [sx, sy] = u.slotS, d = SG.gd(u.x, u.y, sx, sy);
        if (F.moving) {
          // 行進中：速度跟帶頭的人一致，落後就快、超前就慢；目標點一直放在前方，不會追到就停一格、再走一格
          const sp = Math.hypot(F.vx, F.vy), hx = F.vx / sp, hy = F.vy / sp, along = (sx - u.x) * hx + (sy - u.y) * hy;
          u.fgo = true; u.ms = Math.min(ms0, Math.max(30, sp + along * 2.5));
          let tx = sx + hx * Math.max(40, sp * 0.5), ty = sy + hy * Math.max(40, sp * 0.5);
          if (SG.gd(u.x, u.y, tx, ty) < 30) { tx = u.x + hx * 30; ty = u.y + hy * 30; }
          u.home = [tx, ty];
          return;
        }
        if (d > 40) u.fgo = true; else if (d < 14) u.fgo = false; // 帶頭的人停下來，差一點點就不挪
        u.home = u.fgo ? [sx, sy] : [u.x, u.y];
      });
    }
  },
  // 帶頭的人的行進：平滑過的速度，加上走過的足跡（每 16 px 一點，最多 900 px）；存在 o.fmn（o.form 是雙形態武將的形態）
  formOf(o, dt) {
    const F = o.fmn || (o.fmn = { px: o.x, py: o.y, vx: 0, vy: 0, moving: false, trail: [[o.x + 1e-3 * (o.f || 1), o.y]] });
    const k = Math.min(1, dt * 6), vx = (o.x - F.px) / Math.max(dt, 1e-3), vy = (o.y - F.py) / Math.max(dt, 1e-3);
    const jump = Math.hypot(o.x - F.px, o.y - F.py) > 200; // 瞬移（劇情傳送）：足跡重來
    F.px = o.x; F.py = o.y;
    if (jump) { F.vx = F.vy = 0; F.trail = [[o.x, o.y]]; } else { F.vx += (vx - F.vx) * k; F.vy += (vy - F.vy) * k; }
    F.moving = Math.hypot(F.vx, F.vy) > 40;
    const T = F.trail, l = T[T.length - 1];
    if (SG.gd(o.x, o.y, l[0], l[1]) > 16) { T.push([o.x, o.y]); if (T.length > 56) T.shift(); }
    return F;
  },
  // 陣位：沿著足跡往回量 back 的那一點，再往足跡的左右偏 side（偏過去撞樹就站在足跡上）
  slot(F, o, back, side) {
    const T = F.trail;
    let px = o.x, py = o.y, left = back, dx = -(o.f || 1), dy = 0;
    for (let j = T.length - 1; j >= 0 && left > 0; j--) {
      const q = T[j], seg = Math.hypot(q[0] - px, q[1] - py);
      if (seg < 1e-3) continue;
      dx = (q[0] - px) / seg; dy = (q[1] - py) / seg;
      const s = Math.min(seg, left);
      px += dx * s; py += dy * s; left -= s;
    }
    if (left > 0) { px += dx * left; py += dy * left; } // 足跡不夠長：照最後的方向延伸
    let x = px - dy * side, y = py + dx * side;
    if (!SG.MAP.walkable(x, y, SG.MAP.BODY) || !SG.clearLine(px, py, x, y)) { x = px; y = py; }
    if (!SG.MAP.walkable(x, y, SG.MAP.BODY)) { x = o.x; y = o.y; }
    return [x, y];
  },
  // 統計：擊破的敵兵、陣亡的鄉勇
  count() {
    for (const u of this.w.units) {
      if (u.alive || u.counted) continue;
      u.counted = true;
      if (u.team === 1) this.stats.slain++;
      else if (u.recruit) this.stats.lost++;
    }
  },
  // ---- 技能鎖：還沒解鎖的技能不能學 ----
  lock(list) { this.locked = new Set(list); },
  unlock(i, text) { this.locked.delete(i); if (text) this.big(text); },
  // ---- 勝負 ----
  win() {
    if (this.over) return;
    this.over = 'win'; this.stats.t = this.w.t - this.stats.start + this.stats.t0;
    this.stars = [{ text: '通關', ok: true }].concat((this.def.stars || []).map((s) => ({ text: s.text, ok: !!s.ok(this, this.w) })));
    this.w.over = this.w.player.team;
  },
  lose(why) {
    if (this.over) return;
    this.over = 'lose'; this.why = why; this.stats.t = this.w.t - this.stats.start + this.stats.t0;
    this.w.over = 1 - this.w.player.team;
  },
  // ---- 卡點：路障（修橋、渡口水急）。look 決定畫成什麼樣子；主角走近就說 say 這句話（[誰, 話]，10 秒說一次）----
  gate(id, x, y, r, look, say, o) { this.ungate(id); SG.MAP.setGate(id, x, y, r); this.gates.push(Object.assign({ id, x, y, r, look, say, t: -99 }, o || {})); },
  ungate(id) { if (!this.gates.some((g) => g.id === id)) return; SG.MAP.setGate(id); this.gates = this.gates.filter((g) => g.id !== id); },
  gateTalk() {
    const me = this.w.player;
    for (const g of this.gates) if (g.say && me.alive && this.w.t - g.t > 10 && SG.gd(me.x, me.y, g.x, g.y) < g.r + 160) { g.t = this.w.t; this.line(g.say[0], g.say[1]); }
  },
  // ---- 拾獲：地圖上散落的錢囊、糧袋、兵書、裝備，走過去就撿起來（要自己探索才找得到）----
  // kind：gold（n 金）、food（回 n 成生命與法力）、book（n 經驗）、item（id 裝備或消耗品；行囊滿了就留在原地）
  loot(x, y, kind, o) {
    const [px, py] = SG.MAP.walkable(x, y, SG.MAP.BODY) ? [x, y] : SG.MAP.nearestFree(x, y);
    const l = Object.assign({ x: px, y: py, kind, ph: (x * 7 + y * 13) % 6.28 }, o || {});
    l.name = l.name || (kind === 'item' ? SG.ITEM[l.id].name : { gold: '錢囊', food: '糧袋', book: '兵書殘卷' }[kind]);
    this.loots.push(l);
    return l;
  },
  give(u, id) {
    const w = this.w, it = SG.ITEM[id];
    if (!u.iq) u.iq = u.items.map((x) => (x ? 1 : 0));
    const st = w.stackSlot(u, it);
    if (st >= 0) { u.iq[st] = SG.itemQty(u, st) + 1; return true; }
    const slot = u.items.indexOf(null);
    if (slot < 0) return false;
    u.items[slot] = it; u.iq[slot] = 1; w.recalc(u);
    return true;
  },
  pickups() {
    const w = this.w;
    for (const l of this.loots) {
      if (l.got) continue;
      const u = w.units.find((h) => h.alive && h.human && h.kind === 'hero' && h.team === w.player.team && !h.npc && SG.gd(h.x, h.y, l.x, l.y) < 70);
      if (!u) { l.full = false; continue; }
      let text = '';
      if (l.kind === 'gold') { u.gold += l.n; text = `+${l.n} 金`; }
      else if (l.kind === 'food') { u.hp = Math.min(u.maxHp, u.hp + u.maxHp * l.n); u.mp = Math.min(u.maxMp, u.mp + u.maxMp * l.n); text = '生命、法力回復'; }
      else if (l.kind === 'book') { w.addExp(u, l.n / w.tune.exp, true); text = `+${l.n} 經驗`; }
      else if (l.kind === 'item') {
        if (!this.give(u, l.id)) { if (!l.full) { l.full = true; w.tell(u, `行囊滿了，${l.name}先留在這裡`, 'warn'); } continue; }
        text = l.name;
      }
      l.got = true; this.stats.loot++;
      w.tell(u, `拾獲 ${l.name}${l.kind === 'item' ? '' : '：' + text}`, 'info');
      w.dmgEvents.push({ x: l.x, y: l.y - 40, text: `拾獲 ${l.name}`, team: u.team, src: u.id });
      w.fx({ k: 'puff', x: l.x, y: l.y });
    }
  },
  // ---- 村民：不是單位（不擋路、打不到），只在村裡走動或在田裡幹活；主角走近就停下來轉頭說話 ----
  folk(x, y, o) {
    const [px, py] = SG.MAP.walkable(x, y, SG.MAP.BODY) ? [x, y] : SG.MAP.nearestFree(x, y);
    const f = Object.assign({ x: px, y: py, home: [px, py], f: SG.rand() < 0.5 ? -1 : 1, goal: null, wait: SG.rand() * 3, t: -99, walk: false, li: 0, look: (this.folks.length * 5) % 4 }, o || {});
    this.folks.push(f);
    return f;
  },
  folksTick(dt) {
    const me = this.w.player;
    for (const f of this.folks) {
      const d = me.alive ? SG.gd(me.x, me.y, f.x, f.y) : 1e9;
      f.walk = false;
      if (d < (f.near || 150)) { // 停下來跟主角說話；lines 是一段對話（每句隔 3.5 秒，說完 heard），say 是一句閒話（25 秒說一次）
        f.f = me.x < f.x ? -1 : 1; f.talk = true;
        if (f.lines && f.li < f.lines.length) {
          if (this.w.t - f.t > 3.5) { f.t = this.w.t; const L = f.lines[f.li++]; this.line(L[0], L[1]); if (f.li >= f.lines.length) { f.heard = true; if (f.onHeard) f.onHeard(f); } }
        } else if (f.say && this.w.t - f.t > 25) { f.t = this.w.t; this.line(f.name, f.say); }
        continue;
      }
      f.talk = false;
      if (f.work || f.still) continue; // 在田裡幹活、站著不動
      if (f.wait > 0) { f.wait -= dt; continue; }
      if (!f.goal) {
        const a = SG.rand() * Math.PI * 2, r = 60 + SG.rand() * 200, gx = f.home[0] + Math.cos(a) * r, gy = f.home[1] + Math.sin(a) * r * 0.7;
        if (SG.MAP.walkable(gx, gy, SG.MAP.BODY) && SG.clearLine(f.x, f.y, gx, gy)) f.goal = [gx, gy]; else { f.wait = 0.5; continue; }
      }
      const gx = f.goal[0] - f.x, gy = f.goal[1] - f.y, L = Math.hypot(gx, gy), s = 60 * dt;
      if (L <= s) { f.goal = null; f.wait = 1.5 + SG.rand() * 4; continue; }
      f.x += (gx / L) * s; f.y += (gy / L) * s; f.f = gx < 0 ? -1 : 1; f.walk = true;
    }
  },
  near(u, x, y, r) { return u.alive && SG.gd(u.x, u.y, x, y) < r; },
  // ---- 環境傷害（流矢、熱油、火）：用一個不在場上的「環境」單位當來源，team 是傷害來自哪一隊 ----
  env(team = 1) {
    const E = this._env || (this._env = {});
    return E[team] || (E[team] = SG.unit({ kind: 'creep', spec: SG.NEUTRAL.huangjin, team, x: -9999, y: -9999, hp: 1, maxHp: 1, atk: 0, armor: 0, asp: 100, ms: 0, range: 0, name: '流矢', gold: 0, xp: 0 }));
  },
  hurt(u, amt, team = 1, o) { if (u.alive && !u.untargetable) this.w.damage(this.env(team), u, amt, Object.assign({ magic: true }, o || {})); },
  // ---- 預警：地上先畫出範圍（圓 x,y,r 或線 x1,y1,x2,y2,w），t 秒後才生效，fn(打到的單位) ----
  warn(o) { const z = Object.assign({ t0: o.t, line: o.x1 != null }, o); this.warns.push(z); return z; },
  inWarn(z, u) { return z.line ? SG.segDist(u.x, u.y, [z.x1, z.y1, z.x2, z.y2]) < z.w / 2 + u.r * 0.5 : SG.gd(u.x, u.y, z.x, z.y) < z.r + u.r * 0.5; },
  // 打一隊（team：被打的那一隊）：箭雨、熱油
  strike(x, y, r, t, dmg, team = 0, o) {
    return this.warn(Object.assign({ x, y, r, t, col: '#ff5040', fn: (hit) => { for (const u of hit) if (u.team === team) this.hurt(u, dmg, 1 - team, { stagger: 0.2 }); this.w.fx({ k: 'boom', x, y, r, col: '#c86a3a' }); } }, o || {}));
  },
  warnsTick(dt) {
    if (!this.warns.length) return;
    const due = [];
    this.warns = this.warns.filter((z) => { z.t -= dt; if (z.t <= 0) { due.push(z); return false; } return true; });
    for (const z of due) z.fn(this.w.units.filter((u) => u.alive && !u.untargetable && !u.structure && this.inWarn(z, u)));
  },
  // ---- 火：80 見方的格子，燒一陣子變焦土；順著風向容易往外延燒；站在火裡會被燒 ----
  // 能燒的地方由章節的 fuel(m, x, y) 決定（預設：走得到的地面）；o.dps 每秒傷害、o.life 每格燒幾秒
  fire(x, y, o) {
    const q = 80, i = Math.floor(x / q), j = Math.floor(y / q), k = j * 4096 + i;
    if (this.fires.has(k) || this.burnt.has(k)) return false;
    if (this.fires.size > 900) return false;
    this.fires.set(k, Object.assign({ x: (i + 0.5) * q, y: (j + 0.5) * q, i, j, age: 0, life: 9 + SG.rand() * 4 }, o || {}));
    return true;
  },
  fuel(x, y) { return this.def.fuel ? this.def.fuel(this, x, y) : SG.MAP.walkable(x, y, 0) && !SG.MAP.waterAt(x, y); },
  // ---- 水攻：跟火共用格子，但不會退、只往低地（章節的 lowland(m, x, y)）漫，站在水裡會變慢 ----
  flood(x, y) { return this.fire(x, y, { water: true, life: 1e9 }); },
  firesTick(dt) {
    if (!this.fires.size) return;
    const F = this.fires, wx = this.wind[0], wy = this.wind[1];
    this.fireT = (this.fireT || 0) - dt;
    const pulse = this.fireT <= 0;
    if (pulse) this.fireT = 0.4;
    for (const [k, c] of F) {
      c.age += dt;
      if (c.age > c.life) { F.delete(k); this.burnt.add(k); continue; }
      if (!pulse || c.age < 0.8) continue;
      if (c.water) { // 水往四周的低地漫，每 0.4 秒一格的機率
        for (const [di, dj] of [[1, 0], [-1, 0], [0, 1], [0, -1]]) { const x = (c.i + di + 0.5) * 80, y = (c.j + dj + 0.5) * 80; if (SG.rand() < 0.22 && this.def.lowland && this.def.lowland(this, x, y)) this.flood(x, y); }
        continue;
      }
      for (let dj = -1; dj <= 1; dj++) for (let di = -1; di <= 1; di++) {
        if (!di && !dj) continue;
        const L = Math.hypot(di, dj), dot = (di * wx + dj * wy) / L, p = 0.05 * (1 + 3 * Math.max(0, dot)) * (dot < -0.3 ? 0.25 : 1);
        const x = (c.i + di + 0.5) * 80, y = (c.j + dj + 0.5) * 80;
        if (SG.rand() < p * (this.def.spreadMul ? this.def.spreadMul(this, x, y) : 1) && this.fuel(x, y)) this.fire(x, y, { dps: c.dps }); // spreadMul：章節可以讓某些地方燒得特別快（船陣）
      }
    }
    if (!pulse) return;
    for (const u of this.w.units) {
      if (!u.alive || u.untargetable || u.structure || u.fireproof || u.boat) continue;
      const c = F.get(Math.floor(u.y / 80) * 4096 + Math.floor(u.x / 80));
      if (c && c.water) { u.st.slow = Math.max(u.st.slow, 0.5); u.st.slowAmt = Math.max(u.st.slowAmt, 0.45); u.inWater = true; continue; }
      if (c && c.age > 0.3) { this.hurt(u, (c.dps || 70) * 0.4, u.team === 0 ? 1 : 0, { quiet: !u.human }); u.st.burn = Math.max(u.st.burn, 0.5); }
    }
  },
  burning(x, y, r) { for (const c of this.fires.values()) if (!c.water && SG.gd(c.x, c.y, x, y) < r) return true; return false; },
  flooded(x, y) { const c = this.fires.get(Math.floor(y / 80) * 4096 + Math.floor(x / 80)); return !!(c && c.water); },
  // ---- 讀條：站著不動 t 秒完成（移動、被控、挨打就中斷，o.hurt === false 時挨打不斷）----
  chan(u, t, label, done, o) { u.chan = Object.assign({ t, t0: t, label, done, x: u.x, y: u.y, hp: u.hp }, o || {}); },
  chansTick(dt) {
    for (const u of this.w.units) {
      const c = u.chan;
      if (!c) continue;
      const moved = SG.gd(u.x, u.y, c.x, c.y) > 30, hit = c.hurt !== false && u.hp < c.hp - 1;
      if (!u.alive || moved || hit || u.st.stun > 0) { u.chan = null; if (c.fail) c.fail(moved ? '移動' : '中斷'); continue; }
      c.hp = Math.max(c.hp, u.hp);
      if ((c.t -= dt) <= 0) { u.chan = null; c.done(); }
    }
  },
  // 站在 (x, y) 附近、沒在走也沒在出招，就自動開始讀條（key 區分是哪一件事）
  idle(u) { const I = u.input || {}; return !I.moveTo && !(I.wp && I.wp.length) && !u.act && !(I.target && I.target.alive && !I.target.asleep); }, // 選著一個還不知情的敵人不算在打
  chanAt(u, key, x, y, r, t, label, done, o) {
    if (!u.alive || u.chan || !this.near(u, x, y, r) || !this.idle(u)) return false;
    this.chan(u, t, label, done, Object.assign({ key }, o || {}));
    return true;
  },
  // ---- 船：u 站在船上，只能在水上走（o.land：可以靠岸的地方由 canLand(x, y) 判斷，靠岸就下船）----
  // 玩家的船：右鍵點哪裡就往哪裡划；其他人的船設 b.goal。crew：船上的其他人，跟著船走
  boat(u, o) {
    const b = Object.assign({ u, x: u.x, y: u.y, goal: null, sp: 230, crew: [], f: u.f || 1, big: false }, o || {});
    u.x = b.x; u.y = b.y; // o.x、o.y：船的起點（在水上）
    this.boats.push(b); u.boat = b;
    return b;
  },
  unboat(b) { if (b.u.boat === b) b.u.boat = null; for (const c of b.crew) c.boat = null; this.boats = this.boats.filter((o) => o !== b); },
  sailable(x, y) { return SG.MAP.waterAt(x, y) || (this.def.sail && this.def.sail(this, x, y)); },
  boatsTick(dt) {
    for (const b of this.boats.slice()) {
      const u = b.u, I = u.input || {};
      if (u === this.w.player) { if (I.moveTo) { b.goal = I.moveTo.slice(); I.moveTo = null; } I.wp = null; }
      if (!u.alive) { this.unboat(b); continue; }
      if (b.goal && !b.stop) {
        const dx = b.goal[0] - b.x, dy = b.goal[1] - b.y, L = Math.hypot(dx, dy), s = Math.min(L, b.sp * dt);
        if (L < 4) b.goal = null;
        else {
          const nx = b.x + (dx / L) * s, ny = b.y + (dy / L) * s;
          // 路障（例如橫在江上的蒙衝）也擋船
          if (this.sailable(nx, ny) && !this.gates.some((g) => SG.gd(nx, ny, g.x, g.y) < g.r)) { b.x = nx; b.y = ny; if (Math.abs(dx) > 2) b.f = dx < 0 ? -1 : 1; b.moving = true; }
          else if (b.land && SG.MAP.walkable(nx, ny, SG.MAP.BODY) && (!b.landOk || b.landOk(nx, ny))) { b.landed = true; this.unboat(b); u.x = nx; u.y = ny; b.crew.forEach((c, i) => { if (c.alive) { c.x = nx - b.f * (30 + i * 20); c.y = ny + ((i % 3) - 1) * 30; const p = SG.MAP.nearestFree(c.x, c.y); c.x = p[0]; c.y = p[1]; } }); b.onLand && b.onLand(b); continue; }
          else { b.goal = null; b.moving = false; }
        }
      } else b.moving = false;
      b.still = b.moving ? 0 : (b.still || 0) + dt; // 停了多久（在船上讀條要船停住）
      u.x = b.x; u.y = b.y; u.f = b.f; u.boat = b;
      if (u.input && u.input.target == null && !u.act) u.loop = 'idle';
      b.crew.forEach((c, i) => { if (!c.alive) return; c.x = b.x - b.f * (40 + (i % 3) * 34); c.y = b.y + ((i / 3) | 0) * 22 - 10; c.f = b.f; c.boat = b; });
    }
  },
  alive(list) { return list.filter((u) => u.alive); },
};

// prev：分幕的章（def.next）上一幕的結果 { vars, stats, lootN }；戰果接著算，評星可以看 m.prev.vars
export function startMission(w, def, prev) {
  const s0 = prev ? prev.stats : { slain: 0, lost: 0, loot: 0, t: 0 };
  const m = Object.assign(Object.create(M_), { def, w, i: -1, t: 0, objs: [], marks: [], gates: [], loots: [], folks: [], vars: {}, timers: [], prints: [], locked: new Set(), over: null, stars: null, why: '',
    warns: [], fires: new Map(), burnt: new Set(), boats: [], wind: [0, 0], prev: prev || null, lootN0: prev ? prev.lootN : 0,
    stats: { start: w.t, slain: s0.slain, lost: s0.lost, loot: s0.loot, t: 0, t0: s0.t } });
  w.campaign.mission = m;
  // 技能鎖：包住這個世界的 canLearn（只鎖主角）
  const can = w.canLearn;
  w.canLearn = function (u, i) { return u === w.player && m.locked.has(i) ? '這一章還沒學會這招' : can.call(this, u, i); };
  m.next();
  return m;
}
